import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card } from "../../../common";
import { useSelector } from "react-redux";
import { useGetTrackCompanyListQuery } from "../../../../store/Company/companyApiSlice";
import { EnterpriseCard } from "./EnterpriseCard";
import SearchBar from "../../../common/SearchBar.jsx";
import { debounce } from "../../../../utils/Helper.js";
export const EnterpriseTrackedCompanies = () => {
  const { id } = useParams();
  const { token } = useSelector((state) => state.auth);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(9);
  const [enterpriseData, setEnterpriseData] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const { data, refetch } = useGetTrackCompanyListQuery({
    token,
    id,
    page,
    limit,
    searchTerm
  }, {skip: !id});

  useEffect(() => {
    if (data) {
      setEnterpriseData(data);
    }
  }, [data]);

  useEffect(() => {
    refetch();
  }, [searchTerm])

  const handleChange = (value) => {
    setSearchTerm(value);
  };

  const optimizedFn = useCallback(debounce(handleChange), []);

  return (
    <Card classes="w-full md:col-start-1 md:col-end-10 ">
      <div className="flex justify-between">
        <div>
          <h3 className="text-left text-f24 text-primary font-bold">
            Enterprise Companies
          </h3>
          <p className="text-left text-f16 text-secondarytwo mb-4">
            Track companies seamlessly with enterprise solution.
          </p>
        </div>
        <SearchBar onSearch={optimizedFn} />
      </div>
      <EnterpriseCard
        enterpriseData={enterpriseData}
        page={page}
        setPage={setPage}
        searchById={false}
        enterpriseID={id}
      />
    </Card>
  );
};
